import React, { useState } from "react";
// import Modal, { Theatre, ModalHeader, Prompt, ModalFooter, ModalBody, Sheets } from "@ingka/modal";
import Modal, { Sheets, ModalBody } from "@ingka/modal";

import ProductDetailModal from '../Section/ProductDetailModal';


const ModalUI = (props) => {

    const [modalOpen, setModalOpen] = useState(true);
    console.log("Model :::::", props);
    console.log("modalOpen :::::", modalOpen);

    const handleClosebtn = () => {
        setModalOpen(false);
        props.closebtn(true);
    }

    return (
        <>
            <div className="cover-box"></div>
            
            <div className="popup-box">
                {modalOpen && <Modal
                    visible={true} // Opens / Closes modal
                    handleCloseBtn={handleClosebtn} // on Internal close request
                >
                    <Sheets
                        alignment="right"
                        aria-label="Accessibility header for a modal"
                    >
                        <ModalBody>
                            <ProductDetailModal />
                        </ModalBody>
                    </Sheets>
                </Modal>}

                {!modalOpen && <Modal
                    visible={false} // Opens / Closes modal
                    handleCloseBtn={handleClosebtn} // on Internal close request
                >
                    <Sheets
                        alignment="right"
                        aria-label="Accessibility header for a modal"
                    >
                        <ModalBody>
                            <ProductDetailModal />
                        </ModalBody>
                    </Sheets>
                </Modal>}
            </div>
        </>
    );
}

export default ModalUI;
